import { useForm } from '@givebacks/formy';
import { CardCvcElement, Elements, useElements, useStripe } from '@stripe/react-stripe-js';
import { Box } from 'ui';

import { useLoadedStripe } from '../../../../hooks/use-load-stripe/useLoadedStripe';
import { StripeCVVForm, StripeCVVFormTransformedValues } from './StripeCard';
import styles from './StripeCardInfoForm.module.css';

const Cvv = () => {
  const stripe = useStripe();
  const elements = useElements();

  const form = useForm<StripeCVVForm, StripeCVVFormTransformedValues>(
    {
      initialValues: {
        token: '',
      },
      validate: {
        token: () => null,
      },
      transformValues: async () => {
        if (!stripe || !elements) {
          return { token: '' };
        }
        const cvvElement = elements.getElement(CardCvcElement);
        if (!cvvElement) {
          return { token: '' };
        }

        const { token, error } = await stripe.createToken('cvc_update', cvvElement);
        if (error) {
          form.setFieldError('token', error.message);
          return { token: '' };
        }
        form.setFieldValue('token', token.id);
        return { token: token.id };
      },
    },
    {
      id: 'stripe_cvv',
    }
  );

  return (
    <CardCvcElement
      options={{
        style: {
          base: {
            fontFamily: 'Poppins, sans-serif',
          },
        },
      }}
    />
  );
};

const StripeCVV = () => {
  const stripe = useLoadedStripe();

  return (
    <Elements stripe={stripe}>
      <Box w="100px" className={styles.stripePaymentElement}>
        <Cvv />
      </Box>
    </Elements>
  );
};

export { StripeCVV };
